import kaplay from "kaplay";
// import "kaplay/global"; // uncomment if you want to use without the k. prefix
import { omori_controls } from "./controls/omori_controls";
import { textComponents } from "./components/textComponents";
import { character_sprites } from "./sprites/character_sprites";
import { land_sprites } from "./sprites/land_sprites";
import { load_sprites } from "./sprites/load_sprites";
import { events } from "./events/events";

const k = kaplay({
    height: 1000,
    width: 1500,
    letterbox: true
});

load_sprites(k);
k.loadRoot("./"); // A good idea for Itch.io publishing later
character_sprites(k);
land_sprites(k);
omori_controls(k);
textComponents(k);
events(k);